import { Component } from '@angular/core';
import { PageTitleComponent } from '../../../../components/page-title/page-title.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-support',
  templateUrl: './support.page.html',
  imports: [PageTitleComponent, TranslatePipe],
})
export class SupportPage {}
